<template>
  <b-card
    v-if="approvalFlow.detalle && approvalFlow.detalle.pasos && flow.numero"
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>
        Detalles del flujo #{{flow.numero}} -
        <span v-if="flow.nombreAprobacion">{{flow.nombreAprobacion}}</span>
        <span v-else>{{flow.nomnbreEjecucion}}</span>
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <div
        v-for="step in approvalFlow.detalle.pasos"
        :key="step.id"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.PROCESSING"
              rounded
              v-b-tooltip="'Procesando'"
              size="28"
              variant="light-warning"
            >
              <feather-icon
                size="18"
                icon="LoaderIcon"
              />
            </b-avatar>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.PENDING"
              rounded
              v-b-tooltip="'Pendiente'"
              size="28"
              variant="light-secondary"
            >
              <feather-icon
                size="18"
                icon="AlertCircleIcon"
              />
            </b-avatar>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.APPROVED"
              rounded
              v-b-tooltip="'Aprobado'"
              size="28"
              variant="light-success"
            >
              <feather-icon
                size="18"
                icon="ThumbsUpIcon"
              />
            </b-avatar>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.REJECTED"
              rounded
              v-b-tooltip="'Rechazado'"
              size="28"
              variant="light-danger"
            >
              <feather-icon
                size="18"
                icon="ThumbsDownIcon"
              />
            </b-avatar>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.FORWARDED"
              rounded
              v-b-tooltip="'Reenviado'"
              size="28"
              variant="light-info"
            >
              <feather-icon
                size="18"
                icon="ShuffleIcon"
              />
            </b-avatar>
            <b-avatar
              v-if="step.aprobacionesPasoEstadoId === flowStates.RETURNED"
              rounded
              v-b-tooltip="'Devuelto'"
              size="28"
              variant="light-info"
            >
              <feather-icon
                size="18"
                icon="CornerUpLeftIcon"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="transaction-title">
              {{ step.paso.responsable }}
              <feather-icon
                v-if="step.id === approvalFlow.detalle.ejecucion.pasoActualId"
                size="10"
                variant="warning"
                icon="StarIcon"
              />
            </h6>
            <small>{{ step.fechaInicioPaso | dateFormat }}</small>
          </b-media-body>
        </b-media>
        <div
          class="font-small-2 text-success"
        >
          {{ step.minutosEnPaso | timeApprovals }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';

export default {
  mixin: [ApprovalProcessStates],
  data() {
    return {
      flowStates: ApprovalProcessStates
    };
  },
  props: {
    flow: { type: Object },
    approvalFlow: { type: Object }
  }
};
</script>
